var map = {
	"./bar-chart.svg": "20b0",
	"./bell.svg": "3f5a",
	"./bookmark.svg": "30d7",
	"./dollar-sign.svg": "5274",
	"./folder.svg": "beb1",
	"./mail.svg": "a979",
	"./other.svg": "a745a",
	"./pencil-edit.svg": "4b09",
	"./stopwatch.svg": "6419"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3247";